import { CellDefaultTooltip } from "app/pages/sales-intelligence/common-components/table-cells";

import { StyledSidebarButton } from "./styles";

type Props = {
    className?: string;
    tooltipContent: string;
    onClick: () => void;
    isDisabled?: boolean;
};

const SidebarButton = ({ className, tooltipContent, onClick, isDisabled }: Props) => {
    return (
        <CellDefaultTooltip content={tooltipContent}>
            <StyledSidebarButton
                className={className}
                type={"flat"}
                onClick={onClick}
                iconName={"open-info"}
                iconSize={"sm"}
                iconColor={"blue"}
                isDisabled={isDisabled}
            />
        </CellDefaultTooltip>
    );
};

export default SidebarButton;
